import { useEffect } from 'react';
import NoduloHeader from '../components/nodulo/NoduloHeader';
import NoduloHero from '../components/nodulo/NoduloHero';
import NoduloAbout from '../components/nodulo/NoduloAbout';
import NoduloInfoSection from '../components/nodulo/NoduloInfoSection';
import NoduloJourney from '../components/nodulo/NoduloJourney';
import NoduloBiopsySection from '../components/nodulo/NoduloBiopsySection';
import NoduloTestimonials from '../components/nodulo/NoduloTestimonials';
import NoduloInsurance from '../components/nodulo/NoduloInsurance';
import NoduloFAQ from '../components/nodulo/NoduloFAQ';
import NoduloContact from '../components/nodulo/NoduloContact';
import NoduloFooter from '../components/nodulo/NoduloFooter';
import NoduloWhatsAppFloat from '../components/nodulo/NoduloWhatsAppFloat';
import ProgressBar from '../components/ProgressBar';
import BackToTop from '../components/BackToTop';

export default function NoduloPulmonarPage() {
  useEffect(() => {
    document.title = 'Descobriu um Nódulo Pulmonar? | Dr. Mateus Marques — Cirurgião Torácico em Feira de Santana';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Descobriu um Nódulo Pulmonar? Dr. Mateus Marques é Cirurgião Torácico em Feira de Santana, BA. Diagnóstico preciso, acompanhamento seguro e tratamento adequado — biópsia percutânea, broncoscopia e ressecção minimamente invasiva.');
    const kw = document.querySelector('meta[name="keywords"]');
    if (kw) kw.setAttribute('content', 'nódulo pulmonar, biópsia percutânea, biópsia pulmonar, broncoscopia, ressecção pulmonar, massa pulmonar, cirurgião torácico Feira de Santana, Dr. Mateus Marques');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Descobriu um Nódulo Pulmonar? O Especialista Que Você Precisa Está Aqui');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Diagnóstico preciso, acompanhamento seguro e tratamento adequado. Você não está sozinho nessa jornada. Cirurgião Torácico em Feira de Santana, BA.');

    // Schema markup
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": ["MedicalBusiness", "LocalBusiness"],
          "name": "Dr. Mateus Marques - Cirurgião Torácico",
          "description": "Diagnóstico e tratamento de nódulo pulmonar em Feira de Santana, BA. Biopsia percutânea e ressecção cirúrgica minimamente invasiva.",
          "telephone": "+55-75-98187-2440",
          "email": "mateus.cirtorax@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Feira de Santana",
            "addressRegion": "BA",
            "addressCountry": "BR"
          },
          "medicalSpecialty": "Thoracic Surgery",
          "availableService": [
            { "@type": "MedicalProcedure", "name": "Biopsia Percutânea de Nódulo Pulmonar", "procedureType": "Diagnostic" },
            { "@type": "MedicalProcedure", "name": "Broncoscopia com Biopsia", "procedureType": "Diagnostic" },
            { "@type": "MedicalProcedure", "name": "Ressecção Pulmonar por VATS", "procedureType": "Surgical" }
          ]
        },
        {
          "@type": "Physician",
          "name": "Dr. Mateus Marques",
          "medicalSpecialty": "Thoracic Surgery",
          "address": { "@type": "PostalAddress", "addressLocality": "Feira de Santana", "addressRegion": "BA" }
        }
      ]
    };
    let schemaEl = document.querySelector('#nodulo-schema');
    if (!schemaEl) {
      schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.id = 'nodulo-schema';
      document.head.appendChild(schemaEl);
    }
    schemaEl.textContent = JSON.stringify(schemaData);

    return () => {
      document.title = 'Dr. Mateus Marques — Cirurgião Torácico | Hiperidrose em Feira de Santana';
      document.querySelector('#nodulo-schema')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <ProgressBar />
      <NoduloHeader />
      <main>
        <NoduloHero />
        <NoduloAbout />
        <NoduloInfoSection />
        <NoduloJourney />
        <NoduloBiopsySection />
        <NoduloTestimonials />
        <NoduloInsurance />
        <NoduloFAQ />
        <NoduloContact />
      </main>
      <NoduloFooter />
      <NoduloWhatsAppFloat />
      <BackToTop />
    </div>
  );
}
